module.exports = __webpack_public_path__ + "static/avatar-britta-b03b8a7eb92c643032336c82f9612611.png";